document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('form.klaviyo-form');

  forms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault(); // Prevent default form submission (page reload)

      const emailInput = form.querySelector('input[name="email"]');
      const listIdInput = form.querySelector('input[name="list_id"]');
      const messageDiv = form.querySelector('.klaviyo-form-message');

      const email = emailInput ? emailInput.value.trim() : '';
      const list_id = listIdInput ? listIdInput.value : '';

      // Check if email is empty
      if (!email) {
        if (messageDiv) {
          messageDiv.innerHTML = `<div class="error">Please enter your email address.</div>`;
        }
        return; // Stop execution if email is missing
      }

      // Show loading message
      if (messageDiv) {
        messageDiv.innerHTML = `<div class="loading">Loading...</div>`;
      }

      // Create FormData to send via POST
      const formData = new FormData();
      formData.append('action', 'klaviyo_subscribe'); // Required for WordPress admin-ajax
      formData.append('email', email);
      if (list_id) {
        formData.append('list_id', list_id);
      }

      // Send AJAX POST request to admin-ajax.php
      fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (messageDiv) {
            if (data.status === 'success') {
              messageDiv.innerHTML = `<div class="success">${data.message}</div>`;
              if (emailInput) emailInput.value = ''; // Clear email input on success
            } else {
              messageDiv.innerHTML = `<div class="error">${data.message}</div>`;
            }
          }
        })
        .catch(error => {
          if (messageDiv) {
            messageDiv.innerHTML = `<div class="error">An error occurred. Please try again later.</div>`;
          }
          console.error('AJAX error:', error);
        });
    });
  });
});

// Klavio Resources Form
document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('form.resource-form');

  forms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault(); // Prevent default form submission (page reload)

      const emailInput = form.querySelector('input[name="email"]');
      const email = emailInput ? emailInput.value.trim() : '';

      const post_id_field = form.querySelector('input[name="post_id"]');
      const post_id = post_id_field ? post_id_field.value.trim() : '';

			const nonceField = form.querySelector('input[name="nonce"]');
			const nonce = nonceField ? nonceField.value.trim() : '';

      const messageDiv = form.querySelector('.klaviyo-form-message');

      // Check if email is empty
      if (!email) {
        if (messageDiv) {
          messageDiv.innerHTML = `<div class="error">Please enter your email address.</div>`;
        }
        return; // Stop execution if email is missing
      }

      // Check if post_id is empty
      if (!post_id) {
        if (messageDiv) {
          messageDiv.innerHTML = `<div class="error">Something went wrong. Please refresh the page and try again.</div>`;
        }
        return; // Stop execution if post_id is missing
      }

      // Show loading message
      if (messageDiv) {
        messageDiv.innerHTML = `<div class="loading">Loading...</div>`;
      }

      // Create FormData to send via POST
      const formData = new FormData();
      formData.append('action', 'klaviyo_subscribe_resources'); // Required for WordPress admin-ajax
      formData.append('email', email);
      formData.append('post_id', post_id);
			formData.append('nonce', nonce);

      // Send AJAX POST request to admin-ajax.php
      fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (messageDiv) {
            if (data.status === 'success') {
              messageDiv.innerHTML = `<div class="success">${data.message}</div>`;
              if (emailInput) emailInput.value = ''; // Clear email input on success
              const file_url = data.file_url;
              if(file_url){
                window.open(file_url, '_blank');
              }
            } else {
              messageDiv.innerHTML = `<div class="error">${data.message}</div>`;
            }
          }
        })
        .catch(error => {
          if (messageDiv) {
            messageDiv.innerHTML = `<div class="error">An error occurred. Please try again later.</div>`;
          }
          console.error('AJAX error:', error);
        });

    });
  });

});


// Klavio mini-courses
document.addEventListener('DOMContentLoaded', function () {
	const forms = document.querySelectorAll('form.mini-courses-form');

	forms.forEach(form => {
		form.addEventListener('submit', function (e) {
			e.preventDefault(); // Prevent default form submission (page reload)

			const emailInput = form.querySelector('input[name="email"]');
			const email = emailInput ? emailInput.value.trim() : '';

			const klaviyo_list_field = form.querySelector('input[name="klaviyo_list"]');
			const klaviyo_list = klaviyo_list_field ? klaviyo_list_field.value.trim() : '';

			const link = form.querySelector('input[name="link"]');
			const linkValue = link ? link.value.trim() : '';

			const nonceField = form.querySelector('input[name="nonce"]');
			const nonce = nonceField ? nonceField.value.trim() : '';

			const messageDiv = form.querySelector('.klaviyo-form-message');

			// Check if email is empty
			if (!email) {
				if (messageDiv) {
					messageDiv.innerHTML = `<div class="error">Please enter your email address.</div>`;
				}
				return; // Stop execution if email is missing
			}

			// Show loading message
			if (messageDiv) {
				messageDiv.innerHTML = `<div class="loading">Loading...</div>`;
			}

			// Create FormData to send via POST
			const formData = new FormData();
			formData.append('action', 'klaviyo_subscribe_mini_courses'); // Required for WordPress admin-ajax
			formData.append('email', email);
			formData.append('klaviyo_list', klaviyo_list);
			formData.append('nonce', nonce);

			// Send AJAX POST request to admin-ajax.php
			fetch('/wp-admin/admin-ajax.php', {
				method: 'POST',
				body: formData,
			})
				.then(response => response.json())
				.then(data => {
					if (messageDiv) {
						if (data.status === 'success') {
							messageDiv.innerHTML = `<div class="success">${data.message}</div>`;
							if (emailInput) emailInput.value = ''; // Clear email input on success
							if(linkValue){
								window.open(linkValue, '_blank');
							}
						} else {
							messageDiv.innerHTML = `<div class="error">${data.message}</div>`;
						}
					}
				})
				.catch(error => {
					if (messageDiv) {
						messageDiv.innerHTML = `<div class="error">An error occurred. Please try again later.</div>`;
					}
					console.error('AJAX error:', error);
				});

		});
	});

});
